import React from 'react';
import { default as __ } from '../../../utils';
import { useCustomizer } from './context';
import Slot from './slot';
import SwapButton from './bar-swap';
import Pinned from '../../../components/utils/pinned';

const Court = ({ cb }) => {
  const { state, actions } = useCustomizer();
  let { duration, mvp, pala, players, win } = state;
  const swap = () => actions.shuffle(0, 1);
  return (
    <>
      <div builder-widget="court">
        <div className="row-start align-start flex-wrap  ">
          <Slot
            {...__.unwrapIterable(
              players.filter(p => !p.team && p.position === 'left'),
            )}
          />
          <Slot
            {...__.unwrapIterable(
              players.filter(p => !p.team && p.position === 'right'),
            )}
          />
          <Slot
            {...__.unwrapIterable(
              players.filter(p => p.team && p.position === 'left'),
            )}
          />
          <Slot
            {...__.unwrapIterable(
              players.filter(p => p.team && p.position === 'right'),
            )}
          />
        </div>
        <Pinned isCenteredX offsetY="-150px">
          <SwapButton onClick={swap} />
        </Pinned>
      </div>

        <br aria-hidden='true'/>
      <div className="col-center align-center owl small-container">
       <button
          type="button"
          className="io-unbutton pill-button txt-uppercase"
          onClick={() => cb(state)}
        >
          {' '}
          Guardar partido
        </button>
          <p className="txt-uppercase txt-center txt-l -purple">
            {win ? 'victoria' : 'derrota'} con {pala.nickname} {mvp && '& MVP'} en {' '}
           {__.unwrapIterable(players.filter(player => player.you)).position}{' '}
          court side  
          </p>
      </div>
        <br aria-hidden='true'/>
        <br aria-hidden='true'/>

    </>
  );
};

export default Court;
